import React from 'react';
import { FormattedMessage } from 'react-intl';
import message from './messages';
import { LOCALES } from "./locales";

const Translate = (id, tagWrapper = true, value= {}) => {
  const history = window.location;

  if(history.search !== '') {
    let query = history.search;
    query = query.split('=');
    if(query[0].includes('_locale'))
      localStorage.setItem('lang', query[1])
  }
  const lang = LOCALES[localStorage.getItem('lang')] || 'en-US';

  // Render text with param
  if(Object.keys(value).length){
    for(let param in value){
      message[lang][id] = message[lang][id].replace(`{${param}}`, value[param])
    }
  }

  return message[lang][id];
}

export default Translate;
